export function canSetAside(item) {
  return Boolean(item) && !item.display_only && item.status === 'scheduled' && item.id != null;
}

export function sumSetAside(items, setAside) {
  const chosen = items.filter(item => canSetAside(item) && setAside.has(item.id));
  return { count: chosen.length, cents: chosen.reduce((sum, item) => sum + Number(item.amount_cents), 0) };
}

export function countedByFigure(item, { bankAccountId, forDate }) {
  return canSetAside(item) && item.bank_account_id === bankAccountId && forDate != null && item.due_date <= forDate;
}

export function lineLabelFor(item) {
  if (!item || item.display_only) return null;
  if (item.kind === 'check') return `check ${String(item.check_number ?? '').replace(/^0+/, '')} · ${item.payee}`;
  if (item.kind === 'bill') return `bill · ${item.payee}${item.is_estimate ? ' (estimate)' : ''}`;
  return null;
}

export function matchLines(lines, items) {
  const unused = [...items];
  return lines.map(line => {
    const at = unused.findIndex(item => lineLabelFor(item) === line.label);
    const item = at >= 0 ? unused.splice(at, 1)[0] : null;
    return { line, item };
  });
}
